/* global Sys, Core, Services */
Sys.ns("Core");

/**
 * The RoundBlocker module.
 *
 * Handling the RoundBlocker feature.
 *
 * @class Core.RoundBlocker
 * @extends Core.Module
 */
Core.GameRound = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.GameRound.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        return {
            roundBlocker: {
                state: {
                    name: "RoundBlocker",
                    execute: function(env) {
                        // stub
                    },
                    waitEvents: {
                        "notify:gameRound.blockersResolved": false
                    }
                }
            },
            presentationEnded: {
                state: {
                    name: "PresentationEnded",
                    execute: function(env) {
                        if (Services.gameRound.isGameOver()) {
                            env.stateHandler.pushState(env.states.roundBlocker);
                        }
                    },
                    waitEvents: {}
                }
            },
            stopped: {
                queue: [
                    function(env) {
                        env.stateHandler.pushState(env.states.presentationEnded);
                    }
                ]
            }
        };
    }
};

Core.GameRound = Sys.extend(Core.Module, Core.GameRound, "Core.GameRound");
